/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertyRepairSyncResponse } from '../models/PropertyRepairSyncResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntegrationsPropertiesService {
    /**
     * @param id
     * @returns PropertyRepairSyncResponse Ok
     * @throws ApiError
     */
    public static repairSyncProperty(
        id: number,
    ): CancelablePromise<PropertyRepairSyncResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/properties/{id}/actions/repair-sync',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
}
